import { Entry } from '../Entry'

export function Entry20240703() {
  return (
    <Entry title="03/07/2024 - v3.7.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15944/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
